import { AddFlowContainer as AddFlow } from './AddFlowContainer'

// eslint-disable-next-line import/no-default-export
export default AddFlow
